import * as React from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronRight, Trash2 } from "lucide-react";
import { MarkdownRenderer } from "@/components/feature/markdown/markdownRenderer";
import {
  BusinessReportOutcomeResultWithDocumentName,
  removeBusinessReportOutcomeResult,
} from "@/store/slices/snapshotCompareSlice";
import { useToggle } from "react-use";
import { useAppDispatch } from "@/store/hooks";

interface Props {
  result: BusinessReportOutcomeResultWithDocumentName;
}

export const GridSidebarComparisonListRow: React.FC<Props> = ({ result }) => {
  const [isExpanded, toggleExpanded] = useToggle(false);
  const dispatch = useAppDispatch();

  const handleRemove = (resultId: string) => {
    dispatch(removeBusinessReportOutcomeResult(resultId));
  };

  return (
    <div className="rounded-lg border">
      <div className="flex items-center justify-between bg-ui-app-background p-2">
        <div className="flex-1 cursor-pointer" onClick={toggleExpanded}>
          <h4 className="mb-0 text-sm font-medium">
            {result.documentName} - {result.name}
          </h4>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => handleRemove(result.id)}
          className="text-red-500 hover:text-red-700"
        >
          <Trash2 size={16} />
        </Button>
        <Button variant="ghost" size="sm" onClick={toggleExpanded}>
          {isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        </Button>
      </div>

      {isExpanded && (
        <div className="mt-2">
          <div className="mt-2 rounded p-3 text-sm">
            <MarkdownRenderer content={result.result} evidences={[]} processCitations={true} />
          </div>
        </div>
      )}
    </div>
  );
};
